// El terminali üst çubuğu için (i) rehber düğmesi.
// Okutma odağını çalmaz: sekme sırasına girmez (tabIndex -1) ve fareyle/dokunarak basılınca
// odak barkod kutusunda kalır (mousedown preventDefault). Rehber kapanınca odak barkod kutusuna döner.
// Boyut: WmsNavBar'daki Çıkış düğmesiyle aynı (mobilde 40px, büyük ekranda 44px).
import React from 'react';
import GuideButton from '../../common/guide/GuideButton';
import type { GuideKey } from '../../../guides/registry';

const WmsTerminalGuideButton: React.FC<{ guideKey: GuideKey }> = ({ guideKey }) => (
  <GuideButton
    guideKey={guideKey}
    size="small"
    tabIndex={-1}
    onMouseDown={(e) => e.preventDefault()}
    sx={{
      color: 'text.secondary',
      flexShrink: 0,
      width: { xs: 40, sm: 44 },
      height: { xs: 40, sm: 44 },
      minWidth: { xs: 40, sm: 44 },
      minHeight: { xs: 40, sm: 44 },
    }}
  />
);

export default WmsTerminalGuideButton;
